@if (bericht; as b) {
  <div class="lade-quellen" role="status" aria-live="polite">
    <div class="lade-quellen__kopf">
      <mat-icon class="lade-quellen__icon">cloud_download</mat-icon>
      <span class="lade-quellen__titel">
        MSWR-MOS geladen@if (b.name) { <span class="lade-quellen__zeile">– {{ b.name }}</span> }
        <span class="lade-quellen__meta">&middot; {{ b.gestartet | date: 'HH:mm:ss' }}</span>
      </span>
      <button type="button" class="lade-quellen__schliessen"
        title="Meldung ausblenden" aria-label="Meldung ausblenden"
        (click)="schliessen()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    @if (b.quellen.length === 0 && b.stand === undefined) {
      <p class="lade-quellen__hinweis">
        <mat-icon>hourglass_top</mat-icon>
        <span>Daten werden geladen &hellip;</span>
      </p>
    } @else if (b.quellen.length > 0) {
      <!-- Eine Zeile je geladener MOS-Datei (dieselbe Datei zählt einmal, mit der Zahl der
           Karten) bzw. der Hinweis auf den Einzelabruf ohne Snapshot. -->
      <p class="lade-quellen__abschnitt">Vorhersagedateien (MOS), frisch von der Wetterdaten-API</p>
      <ul class="lade-quellen__liste">
        @for (q of b.quellen; track q.art + ':' + q.name) {
          <li class="lade-quellen__quelle">
            <mat-icon>{{ icon(q) }}</mat-icon>
            <span class="lade-quellen__name">{{ beschreibung(q) }}</span>
            <span class="lade-quellen__stand">
              @if (q.stand) {
                Stand: {{ q.stand | date: 'dd.MM.yyyy HH:mm' }} Uhr
              } @else {
                {{ ohneStand(q) }}
              }
              &middot; {{ q.karten }} {{ q.karten === 1 ? 'Karte' : 'Karten' }}
            </span>
          </li>
        }
      </ul>
    }

    <!-- Von wann die Daten in den Caches des Rest-Service sind (GET forecast/stand): je
         Sammlung der Wetterdaten-API der jüngste und älteste Stand der Stationseinträge,
         für die MOS-Dateien ein gemeinsamer Stand – sie werden in einem Durchlauf geschrieben. -->
    @if (b.stand === null) {
      <p class="lade-quellen__hinweis">
        <mat-icon>info</mat-icon>
        <span>Stand der Caches des Rest-Service nicht abrufbar.</span>
      </p>
    } @else if (b.stand; as st) {
      <p class="lade-quellen__abschnitt">Vorhersagepakete der Wetterdaten-API, die
        {{ b.name ? '„' + b.name + '“' : 'dieser Umfang' }} geladen hat
        <span class="lade-quellen__meta">({{ st.redis ? 'Stand aus Redis' : 'Stand aus dem Rest-Service, ohne Redis' }})</span></p>
      @if (st.sammlungen.length === 0) {
        <p class="lade-quellen__hinweis"><mat-icon>info</mat-icon><span>Keine Box hat Stationsvorhersagen benutzt.</span></p>
      } @else {
        <ul class="lade-quellen__liste">
          @for (s of st.sammlungen; track s.sammlung) {
            <li class="lade-quellen__quelle">
              <mat-icon>inventory_2</mat-icon>
              <span class="lade-quellen__name">{{ s.sammlung }}</span>
              <span class="lade-quellen__stand">
                @if (s.neuesteAktualisierung) {
                  Stand: {{ s.neuesteAktualisierung | date: 'dd.MM.yyyy HH:mm' }} Uhr
                  @if (deutlichAelter(s.aeltesteAktualisierung, s.neuesteAktualisierung)) {
                    (älteste Station {{ s.aeltesteAktualisierung | date: 'dd.MM.yyyy HH:mm' }})
                  }
                } @else {
                  Stand unbekannt
                }
                &middot; {{ s.stationen }} {{ s.stationen === 1 ? 'Station' : 'Stationen' }}
                @if (s.werte?.length) {
                  &middot; {{ s.werte.join(', ') }}
                }
                @if (s.zeilen) {
                  in {{ s.zeilen }} {{ s.zeilen === 1 ? 'Zeile' : 'Zeilen' }}
                }
              </span>
            </li>
          }
        </ul>
      }
      @if (st.snapshotErstellt) {
        <p class="lade-quellen__meta lade-quellen__fuss">Forecast-Snapshot erstellt {{ st.snapshotErstellt | date: 'dd.MM.yyyy HH:mm' }} Uhr</p>
      }
    }
  </div>
}
